var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {}, [
    _vm.list.length || !_vm.listLoading
      ? _c("div", [
          _c(
            "div",
            { staticClass: "app-container" },
            [
              _c(
                "div",
                { staticClass: "button-container" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-add-config",
                      attrs: { type: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCreate()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" Add New Config "),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.list,
                    "element-loading-text": "Loading...",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "ID", width: "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_vm._v(_vm._s(row.id))]
                          },
                        },
                      ],
                      null,
                      false,
                      3529122770
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Config Key",
                      align: "center",
                      width: "250",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("el-tag", { attrs: { type: "primary" } }, [
                                _vm._v(_vm._s(row.configKey)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3763205595
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Config Name",
                      align: "center",
                      width: "200",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(" " + _vm._s(row.configName || "-") + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3261996415
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Config Value", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("strong", [
                                _vm._v(_vm._s(row.configValue || "-")),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1476713527
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Countries",
                      align: "center",
                      width: "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " + _vm._s(row.countries || "All") + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4249173584
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Status", align: "center", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.online
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleConfigStatus(
                                            row,
                                            false
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Online ")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleConfigStatus(
                                            row,
                                            true
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Offline ")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2919054188
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Actions",
                      align: "center",
                      width: "200",
                      "class-name": "fixed-width",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpdate(row)
                                    },
                                  },
                                },
                                [_vm._v(" Edit ")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDeleteConfirmation(row)
                                    },
                                  },
                                },
                                [_vm._v(" Delete ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4248716430
                    ),
                  }),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title:
                      _vm.dialogStatus === "create"
                        ? "Create Config"
                        : "Edit Config",
                    visible: _vm.dialogFormVisible,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogFormVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "dataForm",
                      staticStyle: { width: "500px", "margin-left": "50px" },
                      attrs: {
                        rules: _vm.rules,
                        model: _vm.tempConfigData,
                        "label-position": "left",
                        "label-width": "150px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Config Key", prop: "configKey" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "e.g. monthly_consult_credits_seconds",
                              disabled: _vm.dialogStatus === "update",
                            },
                            model: {
                              value: _vm.tempConfigData.configKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempConfigData, "configKey", $$v)
                              },
                              expression: "tempConfigData.configKey",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                              },
                            },
                            [
                              _vm._v(
                                " Unique identifier for this configuration "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Config Name", prop: "configName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "e.g. Monthly Consult Credits",
                            },
                            model: {
                              value: _vm.tempConfigData.configName,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempConfigData, "configName", $$v)
                              },
                              expression: "tempConfigData.configName",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                              },
                            },
                            [_vm._v(" Display name or description (optional) ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Config Value", prop: "configValue" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "e.g. 300" },
                            model: {
                              value: _vm.tempConfigData.configValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempConfigData, "configValue", $$v)
                              },
                              expression: "tempConfigData.configValue",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                              },
                            },
                            [
                              _vm._v(
                                " The actual value for this configuration "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Countries", prop: "countries" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "Leave empty for all countries or specify: US,UK,TR",
                            },
                            model: {
                              value: _vm.tempConfigData.countries,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempConfigData, "countries", $$v)
                              },
                              expression: "tempConfigData.countries",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                              },
                            },
                            [
                              _vm._v(
                                " Comma-separated country codes or empty for global "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Status", prop: "online" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "inline-prompt": "",
                              "active-text": "Online",
                              "inactive-text": "Offline",
                            },
                            model: {
                              value: _vm.tempConfigData.online,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempConfigData, "online", $$v)
                              },
                              expression: "tempConfigData.online",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogFormVisible = false
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.dialogStatus === "create"
                                ? _vm.createData()
                                : _vm.updateData()
                            },
                          },
                        },
                        [_vm._v(" Confirm ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "Delete Config",
                    visible: _vm.deleteConfirmationVisible,
                    width: "30%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.deleteConfirmationVisible = $event
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "Are you sure you want to delete this configuration? This action cannot be undone."
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.deleteConfirmationVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.deleteItem },
                        },
                        [_vm._v("Delete")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _c("div", [
          _c(
            "div",
            {
              staticClass: "app-container",
              staticStyle: { "text-align": "center", padding: "50px" },
            },
            [
              _c("p", [
                _vm._v(
                  'No configurations available. Click "Add New Config" to create one.'
                ),
              ]),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { type: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.handleCreate()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v(" Add New Config "),
                ]
              ),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }